@if (isVisible) {
  <div [formGroup]="formGroup" class="grid-container">
    <div class="cell">
      <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
    </div>
    @if (exitingSchematic) {
      <div class="grid-x">
        <div class="cell small-12 large-12 medium-12 bold red">
          @if (isAdvancing) {
            Advancing to the next
          } @else {
            Returning to the previous
            } set of questions.  <text-loader [run]="true" [text]="'Please wait'" [interval]="2000" [tickType]="'.'"></text-loader>
          </div>
        </div>
      }
      @if (showSummary && pageIndex === 0 && renderDiagram) {
        <div class="grid-x">
          <div class="cell large-12 medium-12 small-12 bold">
            Casing Plan Schematic
          </div>
          <div class="cell large-12 medium-12 small-12">
            <casing-plan-2d-schematic [casingPlan]="casingPlan" [applicationData]="applicationData" [direction]="wellDirection"></casing-plan-2d-schematic>
          </div>
        </div>
      }
      @if ((!showSummary || pageIndex > 0) && renderDiagram) {
        <div class="grid-x margin-bottom-large">
          <div class="cell small-12 medium-12 large-12 bold">
            Detail Diagram of String {{segmentIndex + 1}} : {{currentSegment?.casingType.definition}}
          </div>
          @if (segmentValid(currentSegment)) {
            <div class="cell large-12 medium-12 small-12">
              @switch (true) {
                @case (wellDirection === directions.Vertical || !currentSegment.hasAngles) {
                  <casing-plan-2d-detail-vertical [applicationData]="applicationData" [segment]="currentSegment" [length]="1" [segmentIndex]="segmentIndex"></casing-plan-2d-detail-vertical>
                }
                @case (wellDirection === directions.Directional && currentSegment.hasAngles) {
                  <casing-plan-2d-detail-directional [applicationData]="applicationData" [segment]="currentSegment" [length]="1" [segmentIndex]="segmentIndex"></casing-plan-2d-detail-directional>
                }
                @default {
                  <casing-plan-2d-detail-horizontal [applicationData]="applicationData" [segment]="currentSegment" [length]="1" [segmentIndex]="segmentIndex"></casing-plan-2d-detail-horizontal>
                }
              }
            </div>
            @if (segmentBoreholeMissing(currentSegment)) {
              <div class="cell small-12 medium-12 large-12 bold red">
                Casing string should have borehole dimensions, but data was not provided.  Casing has been rendered using casing dimensions provided.
              </div>
            }
            @if (segmentCasingMissing(currentSegment)) {
              <div class="cell small-12 medium-12 large-12 bold red">
                Casing string should have casing dimensions, but data was not provided.  Casing has been rendered using borehole dimensions provided.
              </div>
            }
          } @else {
            <div class="cell large-12 medium-12 small-12 bold red">
              Insufficient data to render casing string.
            </div>
          }
        </div>
      }
      <text-loader [run]="!renderDiagram" [text]="'Loading Diagram'" [interval]="750" [tickType]="'.'"></text-loader>
      @if (currentSegment != null && renderDiagram) {
        <div class="grid-x">
          <div class="cell large-4">
            <h4>String Requirements:</h4>
          </div>
          <div class="cell large-5 align-left">
            {{currentSegment.casingType.definition}}
          </div>
          <div class="cell large-3 text-align-right">
            @if (showSegmentRules) {
              Hide Casing Type Rules
            }
            @if (!showSegmentRules) {
              Show Casing Type Rules
            }
            <button (click)="showSegmentRules = !showSegmentRules">
              @if (showSegmentRules) {
                <svg-icon icon="icon-minus" class="small medium-gray"></svg-icon>
              }
              @if (!showSegmentRules) {
                <svg-icon icon="icon-plus" class="small medium-gray"></svg-icon>
              }
            </button>
          </div>
        </div>
        @if (showSegmentRules) {
          <div class="grid-x">
            <div class="cell large-12">
              @switch (true) {
                @case (currentSegment.casingType.definition === casingTypes.DrivePipe) {
                  <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
                  <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
                  <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
                  @if (segmentLength > 200) {
                    <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
                  }
                  @if (segmentIndex === 0) {
                    <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
                  }
                }
                @case (currentSegment.casingType.definition === casingTypes.Surface) {
                  <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
                  <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)</a><br />
                  <a class="rules-link" href="/law-library/10PjtU16v5gi0JOw" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)(1)(3)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)(a)(i)</a><br />
                  <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
                  <a class="rules-link" href="/law-library/10Pjyz16wt2M1hCQ" target="_blank">Groundwater Protection OAC 1501:9-1-08 (M)(2)(c)</a><br />
                  <a class="rules-link" href="/law-library/10Pjx~16way~2ilX" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(4)(b)(c)</a><br />
                  <a class="rules-link" href="/law-library/10PjAd16x01R2uMM" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(2)(3)</a><br />
                  <a class="rules-link" href="/law-library/10PjAb16wUb81qhp" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(5)</a><br />
                  <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
                  @if (hasConductorString && glacialDrift > 100) {
                    <a class="rules-link" href="/law-library/10PjyD16wHVDnD~" target="_blank">Guide Shoe OAC 1501:9-1-08 (M)(4)(e)</a><br />
                  }
                  @if (segmentLength > 200) {
                    <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
                  }
                  @if (segmentIndex === 0) {
                    <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
                  }
                }
                @case (currentSegment.casingType.definition === casingTypes.MineString) {
                  <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
                  <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
                  <a class="rules-link" href="/law-library/10PjAe16x3loyc6" target="_blank">Casing through any underground mine OAC 1501:9-1-08 (M)(2)(b)</a><br />
                  <a class="rules-link" href="/law-library/10Pjyz16wt2M1hCQ" target="_blank">Groundwater Protection OAC 1501:9-1-08 (M)(2)(c)</a><br />
                  <a class="rules-link" href="/law-library/10PjtU16v5gi0JOw" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)(1)(3)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)(a)(i)</a><br />
                  <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
                  <a class="rules-link" href="/law-library/10PjyB16wAWi2FRw" target="_blank">Cement Basket 1501:9-1-08 (M)(2)(e)(i)(iii)</a><br />
                  <a class="rules-link" href="/law-library/10PjyC16wEvj0BPq" target="_blank">Guide Shoe OAC 1501:9-1-08 (M)(2)(d)</a><br />
                  <a class="rules-link" href="/law-library/10PjyE16wLPy1qR7" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(2)(e)</a><br />
                  <a class="rules-link" href="/law-library/10PjAb16wUb81qhp" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(5)</a><br />
                  <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
                  @if (inActiveMineArea) {
                    <a class="rules-link" href="/law-library/10Pjyy16woZb03aj" target="_blank">Casing through an active underground mine OAC 1501:9-1-08 (M)(2)(a)</a><br />
                  }
                  @if (segmentLength > 200) {
                    <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
                  }
                  @if (segmentIndex === 0) {
                    <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
                  }
                }
                @case (currentSegment.casingType.definition === casingTypes.Intermediate1 || currentSegment.casingType.Definition === casingTypes.Intermediate2 || currentSegment.casingType.Definition === casingTypes.Intermediate1Entry || currentSegment.casingType.Definition === casingTypes.Intermediate2Entry) {
                  <a class="rules-link" href="/law-library/10Pjpi16lPFS1SJk" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(3)</a><br />
                  <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
                  <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
                  @if (hasShoe) {
                    <a class="rules-link" href="/law-library/10PjAg16xarS0oRM" target="_blank">Casing Shoe Test OAC 1501:9-1-08 (E)</a><br />
                  }
                  <a class="rules-link" href="/law-library/10PjtS16uLW2qXV" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvs16vHtQmvX" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(3)(4)(6)(8)(a)(ii)</a><br />
                  <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
                  <a class="rules-link" href="/law-library/10Pjyz16wt2M1hCQ" target="_blank">Groundwater Protection OAC 1501:9-1-08 (M)(2)(c)</a><br />
                  <a class="rules-link" href="/law-library/10Pjx016wg~r1~sU" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(6)(b)(c)(d)</a><br />
                  <a class="rules-link" href="/law-library/10PjAh16xfuC19I~" target="_blank">Flow Zone Isolation OAC 1501:9-1-08 (M)(6)(d)(e)</a><br />
                  <a class="rules-link" href="/law-library/10PjAc16wXQzWVE" target="_blank">Annular Pressure OAC 1501:9-1-08 (M)(6)(d)</a><br />
                  <a class="rules-link" href="/law-library/10PjAd16x01R2uMM" target="_blank">Annular Pressure OAC 1501:9-1-08 (N)(3)</a><br />
                  <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
                }
                @case (currentSegment.casingType.definition === casingTypes.Production) {
                  <a class="rules-link" href="/law-library/10Pjpi16lPFS1SJk" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(3)</a><br />
                  <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
                  <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
                  @if (hasShoe) {
                    <a class="rules-link" href="/law-library/10PjAg16xarS0oRM" target="_blank">Casing Shoe Test OAC 1501:9-1-08 (E)</a><br />
                  }
                  <a class="rules-link" href="/law-library/10PjtS16uLW2qXV" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvs16vHtQmvX" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(3)(4)(6)(8)(a)(ii)</a><br />
                  <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
                  <a class="rules-link" href="/law-library/10Pjx116wk4FcI0" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(7)(a)</a><br />
                  <a class="rules-link" href="/law-library/10PjAi16xjtE2Umi" target="_blank">Flow Zone Isolation OAC 1501:9-1-08 (M)(7)(a)(i)</a><br />
                  <a class="rules-link" href="/law-library/10PjAb16wUb81qhp" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(5)</a><br />
                  <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
                }
                @case (currentSegment.casingType.definition === casingTypes.Conductor) {
                  <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
                  <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
                  <a class="rules-link" href="/law-library/10PjtS16uLW2qXV" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)(1)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)(a)(i)</a><br />
                  <a class="rules-link" href="/law-library/10Pjvt16vNF20CEe" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(3)</a><br />
                  <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
                  @if (segmentLength > 200) {
                    <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
                  }
                  @if (segmentIndex === 0) {
                    <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
                  }
                }
                @default {
                  None
                }
              }
            </div>
          </div>
        }
      }
    </div>
  }


